import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import useAuth from "../../../app/hooks/useAuth";
import {
  setSelectedAddressAccount,
  setSelectedAccount,
  setSelectedAddressServiceAccount,
} from "../../../app/redux/slices/app/userDetailsSlice";
import { capitalize } from "../../../app/utils/utils";
import { UserTypes } from "../../constants/commonEnum";
import CentricUserSearch from "./centricUserSearch";

const NewHeader = () => {
  const { logout } = useAuth();

  const dispatch = useDispatch();

  const {
    userAccountDetails,
    getCentricUserLogin,
    selectedAddressAccount,
    selectedAddressServiceAccount,
  } = useSelector((state) => state?.userDetailSlice);

  const [userAccounts, setUserAccounts] = useState(null);
  const [userLoginInfo, setUserLoginInfo] = useState(null);

  const [userAddressAccountDetails, setUserAddressAccountDetails] = useState(
    [],
  );
  const { selectedAccount } = useSelector((state) => state?.userDetailSlice);

  useEffect(() => {
    setUserAccounts(userAccountDetails?.userAccountInfo?.user_accounts);
    setUserLoginInfo(userAccountDetails?.userLoginInfo);
    setUserAddressAccountDetails(
      userAccountDetails?.userAccountInfo?.user_address_details,
    );
  }, [userAccountDetails]);

  useEffect(() => {
    if (userLoginInfo?.userTypeCode === UserTypes.CENTRIC) return;
    if (userAddressAccountDetails?.length > 0) {
      AddressAccountsChanges(userAddressAccountDetails[0]);
    }
  }, [userAddressAccountDetails]);

  const AddressAccountsChanges = (SelectedAddressAccount) => {
    dispatch(setSelectedAddressAccount(SelectedAddressAccount));
    dispatch(
      setSelectedAddressServiceAccount(
        SelectedAddressAccount?.userAddressServcieInfos[0],
      ),
    );

    const selectAccount = userAccounts?.find(
      (x) =>
        x.crm_billing_account_number ===
        SelectedAddressAccount?.userAddressServcieInfos[0]
          ?.crm_billing_account_number,
    );

    if (selectAccount) {
      dispatch(setSelectedAccount(selectAccount));
    }
  };

  const serviceTypeSelection = (accountNo) => {
    const selectAccount = userAccounts?.find(
      (x) => x.crm_billing_account_number === accountNo,
    );

    if (selectAccount) {
      dispatch(setSelectedAccount(selectAccount));
    }
    dispatch(
      setSelectedAddressServiceAccount(
        selectedAddressAccount?.userAddressServcieInfos?.find(
          (a) => a.crm_billing_account_number === accountNo,
        ),
      ),
    );
  };

  const SERVICES = ["FIBER", "TV", "VOIP"];

  const serviceStatusMap = Object.fromEntries(
    SERVICES.map((service) => [service, ""]),
  );

  (selectedAddressServiceAccount?.user_accounts || []).forEach((acc) => {
    const service = acc.service_type_code?.toUpperCase();
    if (service) {
      serviceStatusMap[service] = acc.status?.toUpperCase();
    }
  });

  const statusColorMap = {
    ACTIVE: "active",
    PENDING: "pending",
    SUSPEND: "suspend",
    INACTIVE: "inactive",
  };

  const showUpgrade = SERVICES.some(
    (service) => serviceStatusMap[service] === "INACTIVE",
  );

  const btnAddNewServcie = () => {
    const uerInfo = {
      user_id: userAccountDetails?.userAccountInfo?.user_id,
      user_name: userAccountDetails?.userAccountInfo?.user_name,
      first_name: userAccountDetails?.userAccountInfo?.first_name,
      last_name: userAccountDetails?.userAccountInfo?.last_name,
      email_id: userAccountDetails?.userAccountInfo?.email_id,
      phone_number: userAccountDetails?.userAccountInfo?.phone_number,
      crm_customer_number: selectedAccount?.crm_customer_number,
    };

    const uerInfoString = JSON.stringify(uerInfo);
    const base64String = btoa(uerInfoString);

    if (base64String) {
      const redirectUrl = `${
        process.env.REACT_APP_ENROLL_URL
      }/?uin=${encodeURIComponent(base64String)}`;
      window.open(redirectUrl, "_blank");
    }
  };

  return (
    <>
      <header className="header" id="kt_header">
        <div className="container-fluid">
          <div className="header-wrapper">
            {getCentricUserLogin === false ? (
              <div className="header-menu-wrapper header-menu-wrapper-left left">
                {userLoginInfo?.userTypeCode === UserTypes.CENTRIC ? (
                  <CentricUserSearch />
                ) : (
                  <div className="dropdown-wrapper gap-10px location">
                    <span className="location-icon">
                      <svg
                        width="26"
                        height="38"
                        viewBox="0 0 26 38"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 0.5C5.81286 0.5 0 6.2905 0 13.45C0 23.1625 13 37.5 13 37.5C13 37.5 26 23.1625 26 13.45C26 6.2905 20.1871 0.5 13 0.5ZM13 18.075C10.4371 18.075 8.35714 16.003 8.35714 13.45C8.35714 10.897 10.4371 8.825 13 8.825C15.5629 8.825 17.6429 10.897 17.6429 13.45C17.6429 16.003 15.5629 18.075 13 18.075Z"
                          fill="#0A65E5"
                        />
                      </svg>
                    </span>

                    <div className="dropdown-choose-wrapper">
                      <div className="dropdown-title">
                        Select Service Address
                      </div>
                      <div className="dropdown">
                        <a
                          className="dropdown-toggle"
                          data-bs-toggle="dropdown"
                        >
                          {selectedAddressAccount?.street_address},{" "}
                          {selectedAddressAccount?.city},
                          {selectedAddressAccount?.state},{" "}
                          {selectedAddressAccount?.zip}
                        </a>
                        <ul className="dropdown-menu">
                          {userAddressAccountDetails &&
                            userAddressAccountDetails.map((item, index) => (
                              <li
                                key={index}
                                onClick={(e) => {
                                  e.preventDefault();
                                  AddressAccountsChanges(item);
                                }}
                              >
                                <a className="dropdown-item" href="#">
                                  {item.street_address}, {item.city},{" "}
                                  {item.state}, {item.zip}
                                </a>
                              </li>
                            ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
                <div className="dropdown-wrapper service">
                  <div className="dropdown-choose-wrapper">
                    {/* {selectedAddressAccount?.userAddressServcieInfos &&
                      selectedAddressAccount?.userAddressServcieInfos.map(
                        (item, index) => (
                          <div
                            key={index}
                            className="form-check form-check-inline"
                          >
                            <input
                              className="form-check-input"
                              type="radio"
                              name="exampleRadios"
                              id="exampleRadios1"
                              value="option1"
                              checked={
                                selectedAddressServiceAccount?.serviceType ===
                                item.serviceType
                              }
                              onChange={(e) => {
                                e.preventDefault();
                                serviceTypeSelection(
                                  item.crm_billing_account_number
                                );
                              }}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="exampleRadios1"
                            >
                              {item.serviceType}
                            </label>
                          </div>
                        )
                      )} */}
                    <div className="w-100">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="dropdown-title">Services</div>
                        {showUpgrade && (
                          <a
                            href="#"
                            className="text-cobalt-blue"
                            onClick={(e) => {
                              e.preventDefault();
                              btnAddNewServcie();
                            }}
                          >
                            Upgrade
                          </a>
                        )}
                      </div>

                      <div className="d-flex gap-10px">
                        {SERVICES.map((service) => {
                          const status = serviceStatusMap[service];
                          const color = statusColorMap[status] || "noservice";

                          return (
                            <span
                              key={service}
                              className={`d-flex align-items-center ${
                                status === "ACTIVE" || status === "SUSPEND"
                                  ? "fw-bold"
                                  : ""
                              }`}
                            >
                              <span className="me-1">
                                <img
                                  src={`/images/${color}.svg`}
                                  alt={status || "inactive"}
                                />
                              </span>
                              {service}
                            </span>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="dropdown-wrapper service">
                  <div className="dropdown-choose-wrapper">
                    <div className="dropdown-title">Billing Account Number</div>
                    <div className="dropdown">
                      <a className="text-cobalt-blue fw-600">
                        {selectedAddressServiceAccount?.crm_billing_account_number ||
                          selectedAddressServiceAccount?.crm_billing_account_id}
                      </a>
                    </div>
                  </div>
                </div>
                {/* {userLoginInfo?.userTypeCode === UserTypes.CENTRIC && <div className="dropdown-wrapper service">
                  <div className="dropdown-choose-wrapper">
                    <div className="dropdown">
                      <a target="_blank" className="btn btn-custom startlit_navy flex-fill" href={`${process.env.REACT_APP_ENROLL_URL}?loginprov=sf`}>Enroll New Customer</a>
                    </div>
                  </div>
                </div>} */}
              </div>
            ) : (
              <div className="header-menu-wrapper header-menu-wrapper-left left">
                {" "}
              </div>
            )}
            <div className="d-flex align-items-stretch flex-shrink-0 right topbar">
              <div className="d-flex align-items-stretch flex-shrink-0">
                {/* <div className="d-flex align-items-stretch">
                  <AddToCart />
                </div> */}
                {/* <div className="d-flex align-items-stretch ">
                  <div className="cart d-flex align-items-stretch">
                    <div className="d-flex align-items-center">
                      <a
                        href="#"
                        className="item-icons"
                        onClick={async (e) => {
                          e.preventDefault();
                          await listen(!isListening);
                        }}
                      >
                        <i
                          className={`fa-solid fa-microphone ${
                            isListening ? "mic-icon-on" : "mic-icon-off"
                          }`}
                        ></i>
                      </a>
                    </div>
                  </div>
                </div> */}
                <div className="dropdown-wrapper profile">
                  <div className="dropdown-choose-wrapper">
                    <div className="dropdown-title">
                      <div className="profile-name">
                        Hello <br />
                        <span className="text-cobalt-blue">
                          {capitalize(userLoginInfo?.first_name)}
                          {" " + capitalize(userLoginInfo?.last_name)}
                        </span>
                      </div>
                    </div>
                    <div className="dropdown">
                      <span
                        className="dropdown-toggle "
                        data-bs-toggle="dropdown"
                      >
                        <a className="profile_pic">
                          {userLoginInfo?.first_name
                            ?.charAt(0)
                            .toUpperCase()
                            .slice(0, 1)}
                          {userLoginInfo?.last_name
                            ?.charAt(0)
                            .toUpperCase()
                            .slice(0, 1)}
                        </a>
                      </span>
                      <ul className="dropdown-menu">
                        <li>
                          <a
                            href="void(0)"
                            onClick={(e) => {
                              e.preventDefault();
                              logout();
                            }}
                            className="dropdown-item"
                          >
                            Log out
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default NewHeader;
